import { render, staticRenderFns } from "./PromotionAccount.vue?vue&type=template&id=42f599e0&scoped=true"
import script from "./PromotionAccount.vue?vue&type=script&lang=js"
export * from "./PromotionAccount.vue?vue&type=script&lang=js"
import style0 from "./PromotionAccount.vue?vue&type=style&index=0&id=42f599e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f599e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f599e0')) {
      api.createRecord('42f599e0', component.options)
    } else {
      api.reload('42f599e0', component.options)
    }
    module.hot.accept("./PromotionAccount.vue?vue&type=template&id=42f599e0&scoped=true", function () {
      api.rerender('42f599e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/PromotionAccount.vue"
export default component.exports